import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import _toConsumableArray from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/removerowcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import TableWalker from "../tablewalker";
import { findAncestor, updateNumericAttribute } from "./utils";
/**
 * The remove row command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as `'removeTableRow'` editor command.
 *
 * To remove the row containing the selected cell, execute the command:
 *
 *		editor.execute( 'removeTableRow' );
 *
 * @extends module:core/command~Command
 */

var RemoveRowCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(RemoveRowCommand, _Command);

  function RemoveRowCommand() {
    _classCallCheck(this, RemoveRowCommand);

    return _possibleConstructorReturn(this, _getPrototypeOf(RemoveRowCommand).apply(this, arguments));
  }

  _createClass(RemoveRowCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var model = this.editor.model;
      var doc = model.document;
      var tableCell = findAncestor('tableCell', doc.selection.getFirstPosition());
      this.isEnabled = !!tableCell && tableCell.parent.parent.childCount > 1;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute() {
      var model = this.editor.model;
      var selection = model.document.selection;
      var firstPosition = selection.getFirstPosition();
      var tableCell = findAncestor('tableCell', firstPosition);
      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var currentRow = table.getChildIndex(tableRow);
      var headingRows = table.getAttribute('headingRows') || 0;
      model.change(function (writer) {
        if (headingRows && currentRow <= headingRows) {
          updateNumericAttribute('headingRows', headingRows - 1, table, writer, 0);
        }

        var tableMap = _toConsumableArray(new TableWalker(table, {
          endRow: currentRow
        }));

        var cellsToMove = new Map(); // Get cells from removed row that are spanned over multiple rows.

        tableMap.filter(function (_ref) {
          var row = _ref.row,
              rowspan = _ref.rowspan;
          return row === currentRow && rowspan > 1;
        }).forEach(function (_ref2) {
          var column = _ref2.column,
              cell = _ref2.cell,
              rowspan = _ref2.rowspan;
          return cellsToMove.set(column, {
            cell: cell,
            rowspanToSet: rowspan - 1
          });
        }); // Reduce rowspan on cells that are above removed row and overlaps removed row.

        tableMap.filter(function (_ref3) {
          var row = _ref3.row,
              rowspan = _ref3.rowspan;
          return row <= currentRow - 1 && row + rowspan > currentRow;
        }).forEach(function (_ref4) {
          var cell = _ref4.cell,
              rowspan = _ref4.rowspan;
          return updateNumericAttribute('rowspan', rowspan - 1, cell, writer);
        }); // Move cells to another row.

        var targetRow = currentRow + 1;
        var tableWalker = new TableWalker(table, {
          includeSpanned: true,
          startRow: targetRow,
          endRow: targetRow
        });
        var previousCell;

        for (var _i = 0, _arr = _toConsumableArray(tableWalker); _i < _arr.length; _i++) {
          var _arr$_i = _arr[_i],
              row = _arr$_i.row,
              column = _arr$_i.column,
              cell = _arr$_i.cell;

          if (cellsToMove.has(column)) {
            var _cellsToMove$get = cellsToMove.get(column),
                cellToMove = _cellsToMove$get.cell,
                rowspanToSet = _cellsToMove$get.rowspanToSet;

            var targetPosition = previousCell ? writer.createPositionAfter(previousCell) : writer.createPositionAt(table.getChild(row), 0);
            writer.move(writer.createRangeOn(cellToMove), targetPosition);
            updateNumericAttribute('rowspan', rowspanToSet, cellToMove, writer);
            previousCell = cellToMove;
          } else {
            previousCell = cell;
          }
        }

        writer.remove(tableRow);
      });
    }
  }]);

  return RemoveRowCommand;
}(Command);

export { RemoveRowCommand as default };